import styled from "@emotion/styled";

export const FieldWrapper = styled.div`
  margin-bottom: 10px;
  label {
    font-size: 12px;
  }
  & > .toggle-buttons {
    margin-top: 5px;
    padding: 0px;
    height: 40px;
    background-color: #f4f4f4;
    border-radius: 0.875rem;
    div {
      width: 100%;
      height: 40px;
      button {
        font-size: 12px;
        height: 30px;
        display: flex;
        align-items: center;
        border-radius: 8px;
      }
    }
  }
`;
